export const GARMENT_TYPE_FILTERS = [
  { key: 'all', label: 'All types' },
  { key: 'jacket', label: 'Jacket' },
  { key: 'overcoat', label: 'Overcoat' },
  { key: 'trouser', label: 'Trouser' },
  { key: 'waistcoat', label: 'Waistcoat' },
  { key: 'shirt', label: 'Shirt' },
  { key: 'other', label: 'Other' },
];

export const isTestLineItem = (item) => {
  if (!item) return false;
  if (item.is_test_garment || item._is_test) return true;
  return String(item.product_name || '').toLowerCase().startsWith('test');
};

const TEST_GARMENT_NO_SUFFIX = /(?:TJ|TT|TW|TOC|TS)\d+(?:-Re\d+)?$/i;

export const hasTestGarmentNoSuffix = (garmentNo) => (
  TEST_GARMENT_NO_SUFFIX.test(String(garmentNo || '').toUpperCase())
);

export const isTestGarmentType = (garmentType) => {
  const type = String(garmentType || '').toLowerCase().trim();
  return type.startsWith('test_') || type.startsWith('test ');
};

export const isTestGarment = (garment, linkedLineItem) => {
  if (!garment) return false;
  if (garment.is_test_garment || garment._is_test) return true;
  if (isTestGarmentType(garment.garment_type)) return true;
  if (hasTestGarmentNoSuffix(garment.garment_no)) return true;
  if (linkedLineItem && isTestLineItem(linkedLineItem)) return true;
  return false;
};

export const getGarmentTypeKey = (...texts) => {
  const normalized = texts
    .map((text) => String(text || '').toLowerCase())
    .join(' ')
    .trim();

  if (!normalized) return 'other';
  if (normalized.includes('waistcoat') || normalized.includes('vest')) return 'waistcoat';
  if (normalized.includes('overcoat')) return 'overcoat';
  if (normalized.includes('jacket')) return 'jacket';
  if (normalized.includes('trouser') || normalized.includes('pant')) return 'trouser';
  if (normalized.includes('shirt')) return 'shirt';
  return 'other';
};

export const getLineItemTypeKey = (item) => getGarmentTypeKey(item?.garment_type, item?.product_name);

export const getGarmentRecordTypeKey = (garment, linkedLineItem) => (
  getGarmentTypeKey(garment?.garment_type, linkedLineItem?.garment_type, linkedLineItem?.product_name)
);

export const filterByGarmentType = (items, typeKey, getTypeKey) => {
  if (!typeKey || typeKey === 'all') return items;
  return items.filter((item) => getTypeKey(item) === typeKey);
};
